import { localAPI } from "../api/local";
import * as publicBlogConstants from "../constants/publicBlogConstants";
// const history = createBrowserHistory();
import history from "../config/history";
import { errorHandler } from "./errorHandler";

export const fetchPublicBlogs = () => async (dispatch) => {
  dispatch({
    type: publicBlogConstants.PUBLIC_BLOG_LIST_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/public-blogs?`);
    dispatch({ type: publicBlogConstants.PUBLIC_BLOG_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(publicBlogConstants.PUBLIC_BLOG_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchPublicBlogsAdmin = (handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: publicBlogConstants.PUBLIC_BLOG_LIST_REQUEST,
  });
  try {
    const data = await localAPI.get("/api/public-blogs/admin");
    dispatch({ type: publicBlogConstants.PUBLIC_BLOG_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(publicBlogConstants.PUBLIC_BLOG_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchPublicBlog = (publicBlogId) => async (dispatch) => {
  dispatch({
    type: publicBlogConstants.PUBLIC_BLOG_DETAILS_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/public-blogs/${publicBlogId}`);
    await dispatch({
      type: publicBlogConstants.PUBLIC_BLOG_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    errorHandler(publicBlogConstants.PUBLIC_BLOG_DETAILS_FAIL, error, false, dispatch);
  }
};

export const createPublicBlog = (publicBlog) => async (dispatch) => {
  dispatch({
    type: publicBlogConstants.PUBLIC_BLOG_CREATE_REQUEST,
  });
  try {
    const data = await localAPI.post("/api/public-blogs", publicBlog);
    dispatch({ type: publicBlogConstants.PUBLIC_BLOG_CREATE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(publicBlogConstants.PUBLIC_BLOG_CREATE_FAIL, error, false, dispatch);
  }
};

export const editPublicBlog = (publicBlog) => async (dispatch) => {
  dispatch({
    type: publicBlogConstants.PUBLIC_BLOG_UPDATE_REQUEST,
  });
  try {
    const data = await localAPI.patch(`/api/public-blogs/${publicBlog._id}`, publicBlog);
    dispatch({ type: publicBlogConstants.PUBLIC_BLOG_UPDATE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(publicBlogConstants.PUBLIC_BLOG_UPDATE_FAIL, error, false, dispatch);
  }
};

export const deletePublicBlog = (publicBlogId) => async (dispatch) => {
  dispatch({
    type: publicBlogConstants.PUBLIC_BLOG_DELETE_REQUEST,
  });
  try {
    const data = await localAPI.delete(`/api/public-blogs/${publicBlogId}`);
    dispatch({ type: publicBlogConstants.PUBLIC_BLOG_DELETE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(publicBlogConstants.PUBLIC_BLOG_DELETE_FAIL, error, false, dispatch);
  }
};
